import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { urlify } from '../helpers/utils';
import { LoggerService } from '../services/logger.service';

@Pipe({
    name: 'urlDetect'
})
export class UrlDetectPipe implements PipeTransform {

    constructor(
        private readonly logger: LoggerService
    ) { }

    transform(val: any): any {
        try {
            val = urlify(val);
        } catch (error) {
            this.logger.error('chatpipe', error);
        }
        console.log('chat',val);
        return val
    }
}